// Helper to fetch content via the local Cloudflare Worker proxy.
// This avoids CORS issues when fetching Gutenberg/Gutendex content.

export async function fetchViaWorker(url: string): Promise<Response> {
    const encodedUrl = encodeURIComponent(url);
    // Use the relative API path which will be intercepted by Vite proxy (dev) or Cloudflare Worker (prod)
    const proxyUrl = `/api/fetch?url=${encodedUrl}`;

    console.debug(`[fetchProxy] Requesting: ${proxyUrl} (upstream: ${url})`);

    const response = await fetch(proxyUrl);

    console.debug(`[fetchProxy] Response: ${response.status} ${response.statusText}`, {
        contentType: response.headers.get('content-type')
    });

    if (!response.ok) {
        try {
            // Try parsing JSON error from worker
            const json = await response.json();
            if (json && typeof json === 'object') {
                if (json.code) {
                    // Structured worker error
                    const code = json.code;
                    const status = json.status || response.status;
                    const url = json.url || 'unknown';

                    if (code === 'upstream_status') {
                        throw new Error(`Upstream Error: Server returned ${status} for ${url}`);
                    }
                    if (code === 'blocked_host') {
                        throw new Error(`Security: Host ${json.host} is not in the allowlist.`);
                    }
                    if (code === 'route_missing') {
                        throw new Error(`Worker Error: Route missing (404)`);
                    }
                    throw new Error(`Worker Error [${code}]: ${json.error || 'Unknown error'}`);
                }
                // Fallback for simple JSON error
                if (json.error) {
                    throw new Error(`Worker Error: ${json.error}`);
                }
            }
        } catch (e) {
            // Not JSON or parse failed; fall through to text text
        }

        // Fallback to text body if JSON parsing didn't throw
        let errorText = '';
        try {
            errorText = await response.text();
            if (errorText.length > 200) errorText = errorText.substring(0, 200) + '...';
        } catch (e) { }

        throw new Error(`Proxy Fetch Failed: ${response.status} ${response.statusText}${errorText ? ' - ' + errorText : ''}`);
    }

    return response;
}



export async function fetchTextViaWorker(url: string): Promise<string> {
    const response = await fetchViaWorker(url);
    return response.text();
}

export async function fetchArrayBufferViaWorker(url: string): Promise<ArrayBuffer> {
    const response = await fetchViaWorker(url);
    return response.arrayBuffer();
}
